"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alertVariant = alertVariant;
exports.default = void 0;

var _color = _interopRequireDefault(require("@bootstrap-styled/color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @public
 * @description Basic css helper for different colored Alert components.
 * @param {string} background
 * @param {string} border
 * @param {string} bodyColor
 * @returns {string}
 */
function alertVariant(background, border, bodyColor) {
  return "\n    background-color: ".concat(background, ";\n    border-color: ").concat(border, ";\n    color: ").concat(bodyColor, ";\n  \n    hr {\n      border-top-color: ").concat((0, _color.default)(border).darken(0.5).toString(), ";\n    }\n    .alert-link {\n      color: ").concat((0, _color.default)(bodyColor).darken(0.1).toString(), ";\n    }\n  ");
}

var _default = {
  alertVariant: alertVariant
};
exports.default = _default;